/* eslint-disable max-lines */
import $ from 'jquery';
import riskAssessorQuiz from './riskAssessorQuiz';

riskAssessorQuiz({
    sections: [
        {
            name: 'Exercise',
            banner1: '/images/colicare/riskAssessor/2_Exercise_960.jpg',
            banner2: '/images/colicare/riskAssessor/2_Exercise.jpg',
            alt: '',
            nav: '/images/colicare/riskAssessor/navSprite.png',
            showTitle: false,
            catHide: 'catHide fleft',
            next: 'Diet',
            title: 'Exercise &amp; Activity',
            questions: [
                {
                    questionHis: 'On average, how much time does your horse spend kept in a stall?',
                    questionHer: 'On average, how much time does your horse spend kept in a stall?',
                    answer: [
                        {
                            answerHis: '0 to 5 hours',
                            answerHer: '0 to 5 hours',
                            points: '0'
                        },
                        {
                            answerHis: '6-12 hours',
                            answerHer: '6-12 hours',
                            points: '1'
                        },
                        {
                            answerHis: '13-19 hours',
                            answerHer: '13-19 hours',
                            points: '2'
                        },
                        {
                            answerHis: '20-24 hours',
                            answerHer: '20-24 hours',
                            points: '3'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'exercise1',
                    className: 'qPlain liLeft fourSplit',
                    position: 'question arrowL',
                    qImage: '/images/colicare/riskAssessor/2_Exercise_Horse1.png',
                    qAlt: '',
                    float: 'fright positionLeft',
                    explanationHer:
                        'Research shows that an increased number of hours spent in a stall has been associated with increased risk of colic.<sup>1</sup> If possible, gradually increase the amount of turnout and exercise time your horse receives to help decrease her risk. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Research shows that an increased number of hours spent in a stall has been associated with increased risk of colic.<sup>1</sup> If possible, gradually increase the amount of turnout and exercise time your horse receives to help decrease his risk. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis:
                        'Within the last two weeks, has your horse experienced a significant increase or decrease in his level of exercise (e.g. a week off from regular work or starting a new training regimen)?',
                    questionHer:
                        'Within the last two weeks, has your horse experienced a significant increase or decrease in her level of exercise (e.g. a week off from regular work or starting a new training regimen)?',
                    answer: [
                        {
                            answerHis: 'Yes, his exercise level increased or decreased significantly',
                            answerHer: 'Yes, her exercise level increased or decreased significantly',
                            points: '2'
                        },
                        {
                            answerHis: 'No, his exercise level remained consistent',
                            answerHer: 'No, her exercise level remained consistent',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: true,
                    imgBack: '/images/colicare/riskAssessor/2_Exercise_BarnBG.png',
                    bgClass: 'bkPosition',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Right.png',
                    arrowAlt: '',
                    inputName: 'exercise2',
                    className: 'bgTop',
                    position: 'tright question arrowR',
                    qImage: '',
                    qAlt: '',
                    float: 'hide',
                    explanationHer:
                        'Research suggests that there is a higher risk of colic in horses that have a significant change in activity.<sup>1</sup> To help lower your horse\'s risk, make increases and decreases to your horse\'s workload (duration and intensity) slowly. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Research suggests that there is a higher risk of colic in horses that have a significant change in activity.<sup>1</sup> To help lower your horse\'s risk, make increases and decreases to your horse\'s workload (duration and intensity) slowly. <div class="leftChev">&rsaquo;</div>'
                }
            ]
        },
        {
            name: 'Diet',
            banner1: '/images/colicare/riskAssessor/3_Diet_960.jpg',
            banner2: '/images/colicare/riskAssessor/3_Diet.jpg',
            alt: '',
            nav: '/images/colicare/riskAssessor/navSprite.png',
            showTitle: false,
            catHide: 'catHide fleft',
            next: 'Management',
            title: 'Diet',
            questions: [
                {
                    questionHis:
                        "Within the last two weeks, has your horse's hay changed (e.g. a different cutting, source or type)?",
                    questionHer:
                        "Within the last two weeks, has your horse's hay changed (e.g. a different cutting, source or type)?",
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '10'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'diet1',
                    className: 'qPlain liLeft twoSplit',
                    position: 'question arrowL',
                    qImage: '/images/colicare/riskAssessor/3_Diet_HayBales.png',
                    qAlt: '',
                    float: 'fright positionRight width250',
                    explanationHer:
                        'Sudden changes in batch (cut) or type of hay have been shown to increase the risk of colic by nearly ten times.<sup>2</sup> To help minimize this risk, make hay changes gradually over the course 7-10 days by blending old and new hay. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Sudden changes in batch (cut) or type of hay have been shown to increase the risk of colic by nearly ten times.<sup>2</sup> To help minimize this risk, make hay changes gradually over the course 7-10 days by blending old and new hay. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis: 'Is your horse fed coastal bermudagrass hay?',
                    questionHer: 'Is your horse fed coastal bermudagrass hay?',
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '2'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: true,
                    imgBack: '/images/colicare/riskAssessor/3_Diet_HorseGraze.png',
                    bgClass: 'bkPosition',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Right.png',
                    arrowAlt: '',
                    inputName: 'diet2',
                    className: 'bgTop liRight',
                    position: 'tright question arrowR',
                    qImage: '',
                    qAlt: '',
                    float: 'hide',
                    explanationHer:
                        'Studies show that horses fed bermudagrass hay have an increased likelihood of developing impaction colic.<sup>3</sup> If possible, replacing bermudagrass hay with another type may help to lower this risk. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Studies show that horses fed bermudagrass hay have an increased likelihood of developing impaction colic.<sup>3</sup> If possible, replacing bermudagrass hay with another type may help to lower this risk. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis: 'Does your horse eat hay from a round bale?',
                    questionHer: 'Does your horse eat hay from a round bale?',
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '2'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'diet3',
                    className: 'bgBottom liLeft twoSplit',
                    position: 'question arrowL',
                    qImage: '/images/colicare/riskAssessor/3_Diet_RoundBale.png',
                    qAlt: '',
                    float: 'fright positionRight width200',
                    explanationHer:
                        'Feeding from hay in round bales is associated with an increased risk of colic.<sup>4</sup> For horses prone to colic, square bales or other types of forage such as chopped hay or hay cubes may be a better choice. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Feeding from hay in round bales is associated with an increased risk of colic.<sup>4</sup> For horses prone to colic, square bales or other types of forage such as chopped hay or hay cubes may be a better choice. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis: 'How much grain/concentrate does your horse receive per day?',
                    questionHer: 'How much grain/concentrate does your horse receive per day?',
                    answer: [
                        {
                            answerHis: 'More than 5 lbs. per day',
                            answerHer: 'More than 5 lbs. per day',
                            points: '5'
                        },
                        {
                            answerHis: 'Less than 5 lbs. per day',
                            answerHer: 'Less than 5 lbs. per day',
                            points: '2'
                        },
                        {
                            answerHis: 'None',
                            answerHer: 'None',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Right.png',
                    arrowAlt: '',
                    inputName: 'diet4',
                    className: 'qPlain fleft liRightQ',
                    position: 'tright question arrowR',
                    qImage: '/images/colicare/riskAssessor/3_Diet_Scoop.png',
                    qAlt: '',
                    float: 'positionLeft width200',
                    explanationHer:
                        'Research has shown that horses receiving grain have an increased risk of colic. In particular, horses fed more than 5 lbs a day have a 5x greater risk of developing colic.<sup>5</sup> To help lower this risk, grain should be fed at the minimum amount required to maintain weight and performance. For hard keepers who need grain, feeding it over multiple, small meals is recommended. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Research has shown that horses receiving grain have an increased risk of colic. In particular, horses fed more than 5 lbs a day have a 5x greater risk of developing colic.<sup>5</sup> To help lower this risk, grain should be fed at the minimum amount required to maintain weight and performance. For hard keepers who need grain, feeding it over multiple, small meals is recommended. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis:
                        "Within the last two weeks, has your horse's grain changed (e.g. from pellets to sweet feed, or between two types of pellets)?",
                    questionHer:
                        "Within the last two weeks, has your horse's grain changed (e.g. from pellets to sweet feed, or between two types of pellets)?",
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '5'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'diet5',
                    className: 'sub fleft liLeft bgColor twoSplit qPlain',
                    position: 'question arrowL',
                    qImage: '',
                    qAlt: '',
                    float: 'hide',
                    explanationHer:
                        'Studies indicate that changes in the type of grain your horse receives increase the odds of colic.<sup>2</sup> To help minimize this risk, make any type of grain change gradually over the course 7-10 days. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Studies indicate that changes in the type of grain your horse receives increase the odds of colic.<sup>2</sup> To help minimize this risk, make any type of grain change gradually over the course 7-10 days. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis:
                        'Within the last two weeks, has there been an increase in the amount of grain your horse is fed?',
                    questionHer:
                        'Within the last two weeks, has there been an increase in the amount of grain your horse is fed?',
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '5'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Right.png',
                    arrowAlt: '',
                    inputName: 'diet6',
                    className: 'sub qPlain fleft liRight bgColor',
                    position: 'tright question arrowR',
                    qImage: '',
                    qAlt: '',
                    float: 'hide',
                    explanationHer:
                        'Research has shown that an increase in the amount of grain your horse receives raises the likelihood of colic.<sup>3</sup> To help minimize this risk, make any type of grain change gradually over the course of 7-10 days. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Research has shown that an increase in the amount of grain your horse receives raises the likelihood of colic.<sup>3</sup> To help minimize this risk, make any type of grain change gradually over the course of 7-10 days. <div class="leftChev">&rsaquo;</div>'
                }
            ]
        },
        {
            name: 'Management',
            banner1: '/images/colicare/riskAssessor/4_Management_960.jpg',
            banner2: '/images/colicare/riskAssessor/4_Management.jpg',
            alt: '',
            nav: '/images/colicare/riskAssessor/navSprite.png',
            showTitle: false,
            catHide: 'catHide fleft',
            next: 'History',
            title: 'Management',
            questions: [
                {
                    questionHis: 'Does your horse currently have access to grass pasture for grazing?',
                    questionHer: 'Does your horse currently have access to grass pasture for grazing?',
                    answer: [
                        {
                            answerHis: 'No, my horse does not have access to grass pasture',
                            answerHer: 'No, my horse does not have access to grass pasture',
                            points: '3'
                        },
                        {
                            answerHis: 'My horse has limited access to pasture and/or the grass is poor quality',
                            answerHer: 'My horse has limited access to pasture and/or the grass is poor quality',
                            points: '1'
                        },
                        {
                            answerHis: 'Yes, he has daily access to high-quality grass pasture',
                            answerHer: 'Yes, she has daily access to high-quality grass pasture',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'management1',
                    className: 'qPlain liLeft',
                    position: 'question arrowL',
                    qImage: '/images/colicare/riskAssessor/4_Management_Fence.png',
                    qAlt: '',
                    float: 'fright positionLeft width200',
                    explanationHer:
                        'Studies have shown that horses without access to grazing or those with a recent reduction in grazing time were 3 times more likely to colic than horses at pasture full time.<sup>4</sup> To help reduce this risk, provide your horse as much grass turnout as possible. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Studies have shown that horses without access to grazing or those with a recent reduction in grazing time were 3 times more likely to colic than horses at pasture full time.<sup>4</sup> To help reduce this risk, provide your horse as much grass turnout as possible. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis: 'Is your horse turned out on sandy soil?',
                    questionHer: 'Is your horse turned out on sandy soil?',
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '1'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '0'
                        }
                    ],
                    response: '',
                    bgImage: true,
                    imgBack: '/images/colicare/riskAssessor/4_Management_HorseSandy.png',
                    bgClass: 'bkPosition',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Right.png',
                    arrowAlt: '',
                    inputName: 'management2',
                    className: 'bgTop liRight',
                    position: 'tright question arrowR',
                    qImage: '',
                    qAlt: '',
                    float: 'hide',
                    explanationHer:
                        'Sand colic and impactions are more common when horses graze on pastures with sandy soils.<sup>3</sup> Work with your veterinarian to develop a program that helps limit sand intake and encourage fecal sand clearance. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Sand colic and impactions are more common when horses graze on pastures with sandy soils.<sup>3</sup> Work with your veterinarian to develop a program that helps limit sand intake and encourage fecal sand clearance. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis: 'Does your horse have 24/7 access to clean, fresh water?',
                    questionHer: 'Does your horse have 24/7 access to clean, fresh water?',
                    answer: [
                        {
                            answerHis: 'Yes',
                            answerHer: 'Yes',
                            points: '0'
                        },
                        {
                            answerHis: 'No',
                            answerHer: 'No',
                            points: '3'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'management3',
                    className: 'bgBottom liLeft twoSplit',
                    position: 'question arrowL',
                    qImage: '/images/colicare/riskAssessor/4_Management_Water.png',
                    qAlt: '',
                    float: 'fright positionBucket width200',
                    explanationHer:
                        'Without adequate water intake horses may be at a greater risk for GI trouble, including impaction. Ensure your horse has access to clean, fresh water at all times for optimal health and well-being. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Without adequate water intake horses may be at a greater risk for GI trouble, including impaction. Ensure your horse has access to clean, fresh water at all times for optimal health and well-being. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis:
                        'How often does your horse receive Non-Steroidal Anti-Inflammatory Drugs (NSAIDs) such as bute, Banamine&reg;, or Equioxx&reg;?',
                    questionHer:
                        'How often does your horse receive Non-Steroidal Anti-Inflammatory Drugs (NSAIDs) such as bute, Banamine&reg;, or Equioxx&reg;?',
                    answer: [
                        {
                            answerHis: 'Rarely (approximately 3 times per year or less)',
                            answerHer: 'Rarely (approximately 3 times per year or less)',
                            points: '0'
                        },
                        {
                            answerHis: 'Occasionally (approximately once per month)',
                            answerHer: 'Occasionally (approximately once per month)',
                            points: '2'
                        },
                        {
                            answerHis: 'Frequently (approximately 3 times per month or more)',
                            answerHer: 'Frequently (approximately 3 times per month or more)',
                            points: '4'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Right.png',
                    arrowAlt: '',
                    inputName: 'management4',
                    className: 'qPlain fleft liRightQ',
                    position: 'tright question arrowR',
                    qImage: '/images/colicare/riskAssessor/4_Management_RX.png',
                    qAlt: '',
                    float: 'positionLeft',
                    explanationHer:
                        'While sometimes appropriate for a diagnosed medical condition, it is important for horse owners to be aware that NSAIDs can have detrimental effects on both the stomach and the hindgut. Always work with your veterinarian when medicating your horse with a prescription NSAID like bute or Banamine&reg; and use the lowest dose possible to decrease your horse\'s risk of GI upset. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'While sometimes appropriate for a diagnosed medical condition, it is important for horse owners to be aware that NSAIDs can have detrimental effects on both the stomach and the hindgut. Always work with your veterinarian when medicating your horse with a prescription NSAID like bute or Banamine&reg; and use the lowest dose possible to decrease your horse\'s risk of GI upset. <div class="leftChev">&rsaquo;</div>'
                },
                {
                    questionHis: 'Select the type of deworming program your horse currently receives',
                    questionHer: 'Select the type of deworming program your horse currently receives',
                    answer: [
                        {
                            answerHis: 'My horse is on a daily dewormer',
                            answerHer: 'My horse is on a daily dewormer',
                            points: '0'
                        },
                        {
                            answerHis: 'My horse is dewormed at least twice per year and receives regular fecal tests',
                            answerHer: 'My horse is dewormed at least twice per year and receives regular fecal tests',
                            points: '0'
                        },
                        {
                            answerHis: 'My horse is on a rotational deworming program',
                            answerHer: 'My horse is on a rotational deworming program',
                            points: '1'
                        },
                        {
                            answerHis: 'My horse does not receive any paste or daily dewormers',
                            answerHer: 'My horse does not receive any paste or daily dewormers',
                            points: '4'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'management5',
                    className: 'qPlain liLeft fleft bgColor fourSplit',
                    position: 'question arrowL',
                    qImage: '/images/colicare/riskAssessor/4_Management_Deworm.png',
                    qAlt: '',
                    float: 'fright positionRight',
                    explanationHer:
                        'Research shows that failure to receive appropriate deworming results in an increased likelihood of colic.<sup>3</sup> A sound parasite control program includes fecal egg counts, strategic use of dewormers, as well as conscientious manure and herd management. Work closely with your veterinarian to determine the best deworming protocol for your horse. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Research shows that failure to receive appropriate deworming results in an increased likelihood of colic.<sup>3</sup> A sound parasite control program includes fecal egg counts, strategic use of dewormers, as well as conscientious manure and herd management. Work closely with your veterinarian to determine the best deworming protocol for your horse. <div class="leftChev">&rsaquo;</div>'
                }
            ]
        },
        {
            name: 'History',
            banner1: '/images/colicare/riskAssessor/5_History_960.jpg',
            banner2: '/images/colicare/riskAssessor/5_History.jpg',
            alt: '',
            nav: '/images/colicare/riskAssessor/navSprite.png',
            showTitle: false,
            catHide: 'catHide fleft',
            next: 'Results',
            title: 'History',
            questions: [
                {
                    questionHis: 'Has your horse ever experienced a colic episode and/or had colic surgery?',
                    questionHer: 'Has your horse ever experienced a colic episode and/or had colic surgery?',
                    answer: [
                        {
                            answerHis: 'No, my horse has never experienced a colic episode',
                            answerHer: 'No, my horse has never experienced a colic episode',
                            points: '0'
                        },
                        {
                            answerHis:
                                'Yes, my horse has had 1-2 mild colic episodes that did not require veterinary treatment',
                            answerHer:
                                'Yes, my horse has had 1-2 mild colic episodes that did not require veterinary treatment',
                            points: '1'
                        },
                        {
                            answerHis: 'Yes, my horse has had colic episode(s) that required veterinary treatment',
                            answerHer: 'Yes, my horse has had colic episode(s) that required veterinary treatment',
                            points: '3'
                        },
                        {
                            answerHis: 'Yes, my horse has had colic surgery',
                            answerHer: 'Yes, my horse has had colic surgery',
                            points: '5'
                        }
                    ],
                    response: '',
                    bgImage: false,
                    imgBack: '',
                    bgClass: '',
                    arrowImg: '/images/colicare/riskAssessor/Arrow_Left.png',
                    arrowAlt: '',
                    inputName: 'history1',
                    className: 'qPlain histSplit',
                    position: 'question arrowL',
                    qImage: '',
                    qAlt: '',
                    float: 'hide',
                    explanationHer:
                        'Horses with a history of previous colic are at a four-fold higher risk for future colic episodes.<sup>2</sup> Work with your veterinarian to develop a comprehensive management plan to help lower her odds of developing colic. <div class="leftChev">&rsaquo;</div>',
                    explanationHis:
                        'Horses with a history of previous colic are at a four-fold higher risk for future colic episodes.<sup>2</sup> Work with your veterinarian to develop a comprehensive management plan to help lower his odds of developing colic. <div class="leftChev">&rsaquo;</div>'
                }
            ]
        }
    ],
    levels: [
        {
            level: 'high',
            levelImg: '/images/colicare/riskAssessor/6_Meter_HIGH.png',
            alt: '',
            colic: [
                {
                    surgery: 'Yes',
                    bannerHer:
                        "Your responses indicate that your horse's diet and/or lifestyle put her at <strong>high risk for colic.</strong>",
                    bannerHis:
                        "Your responses indicate that your horse's diet and/or lifestyle put him at <strong>high risk for colic.</strong>",
                    image: '/images/colicare/riskAssessor/6_Results_ChatBubbles.png',
                    alt: '',
                    headline: '',
                    copyHer:
                        'Talk to your veterinarian about management and nutrition strategies to help lower her risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.',
                    copyHis:
                        'Talk to your veterinarian about management and nutrition strategies to help lower his risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.',
                    cta: 'Learn More',
                    url: 'http://blog.smartpakequine.com/2012/10/colic-101/'
                },
                {
                    surgery: 'No',
                    bannerHer:
                        "Your responses indicate that your horse's diet and/or lifestyle put her at <strong>high risk for colic</strong>. Talk to your veterinarian about management and nutrition strategies to help lower her risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.",
                    bannerHis:
                        "Your responses indicate that your horse's diet and/or lifestyle put him at <strong>high risk for colic</strong>. Talk to your veterinarian about management and nutrition strategies to help lower his risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.",
                    image: '/images/colicare/CC15k.png',
                    alt: '',
                    headline: 'Your horse could be eligible for up to $15,000 of colic surgery coverage',
                    copyHer:
                        'Your horse is an excellent candidate for a daily hindgut health supplement that contains prebiotics, enzymes, and yeast to help support balanced digestion. You may also want to consider applying for <strong>ColiCare&trade;</strong>, our FREE $15,000 colic surgery reimbursement program. ColiCare combines a veterinary-directed wellness program with our best hindgut support to give your horse the most comprehensive approach to preventive care.',
                    copyHis:
                        'Your horse is an excellent candidate for a daily hindgut health supplement that contains prebiotics, enzymes, and yeast to help support balanced digestion. You may also want to consider applying for <strong>ColiCare&trade;</strong>, our FREE $15,000 colic surgery reimbursement program. ColiCare combines a veterinary-directed wellness program with our best hindgut support to give your horse the most comprehensive approach to preventive care.',
                    cta: 'Get Started',
                    url: '/colicare-eligible-supplements-1513pc'
                }
            ]
        },
        {
            level: 'moderate',
            levelImg: '/images/colicare/riskAssessor/6_Meter_MEDIUM.png',
            alt: '',
            colic: [
                {
                    surgery: 'Yes',
                    bannerHer:
                        "Your responses indicate that your horse's diet and/or lifestyle put her at <strong>moderate risk for colic.</strong>",
                    bannerHis:
                        "Your responses indicate that your horse's diet and/or lifestyle put him at <strong>moderate risk for colic.</strong>",
                    image: '/images/colicare/riskAssessor/6_Results_ChatBubbles.png',
                    alt: '',
                    headline: '',
                    copyHer:
                        'Certain management strategies can help lower her risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.',
                    copyHis:
                        'Certain management strategies can help lower his risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.',
                    cta: 'Learn More',
                    url: 'http://blog.smartpakequine.com/2012/10/colic-101/'
                },
                {
                    surgery: 'No',
                    bannerHer:
                        "Your responses indicate that your horse's diet and/or lifestyle put her at <strong>moderate risk for colic</strong>. Certain management strategies can help lower her risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.",
                    bannerHis:
                        "Your responses indicate that your horse's diet and/or lifestyle put him at <strong>moderate risk for colic</strong>. Certain management strategies can help lower his risk, such as maximizing turnout time, minimizing dietary changes, and providing consistent exercise.",
                    image: '/images/colicare/CC15k.png',
                    alt: '',
                    headline: 'Your horse could be eligible for up to $15,000 of colic surgery coverage',
                    copyHer:
                        "To further support your horse's hindgut health, consider applying for <strong>ColiCare&trade;</strong>, our FREE $15,000 colic surgery reimbursement program. ColiCare combines a veterinary-directed wellness program with our best hindgut support supplements to give your horse the most comprehensive approach to preventive care.",
                    copyHis:
                        "To further support your horse's hindgut health, consider applying for <strong>ColiCare&trade;</strong>, our FREE $15,000 colic surgery reimbursement program. ColiCare combines a veterinary-directed wellness program with our best hindgut support supplements to give your horse the most comprehensive approach to preventive care.",
                    cta: 'Get Started',
                    url: '/colicare-eligible-supplements-1513pc'
                }
            ]
        },
        {
            level: 'low',
            levelImg: '/images/colicare/riskAssessor/6_Meter_LOW.png',
            alt: '',
            colic: [
                {
                    surgery: 'Yes',
                    bannerHer:
                        "Congratulations - your responses indicate that your horse's current management plan is <strong>helping to keep her risk of colic low</strong>!",
                    bannerHis:
                        "Congratulations - your responses indicate that your horse's current management plan is <strong>helping to keep his risk of colic low</strong>!",
                    image: '/images/colicare/riskAssessor/6_Results_ChatBubbles.png',
                    alt: '',
                    headline: '',
                    copyHer:
                        "If you'd like to learn some more strategies to help manage the risk of colic, check out our blog for additional tips.",
                    copyHis:
                        "If you'd like to learn some more strategies to help manage the risk of colic, check out our blog for additional tips.",
                    cta: 'Learn More',
                    url: 'http://blog.smartpakequine.com/2012/10/colic-101/'
                },
                {
                    surgery: 'No',
                    bannerHer:
                        "Congratulations - your responses indicate that your horse's current management plan is helping to keep her <strong>risk of colic low</strong>!",
                    bannerHis:
                        "Congratulations - your responses indicate that your horse's current management plan is helping to keep his <strong>risk of colic low</strong>!",
                    image: '/images/colicare/CC15k.png',
                    alt: '',
                    headline: 'Your horse could be eligible for up to $15,000 of colic surgery coverage',
                    copyHer:
                        'Keep up the good work, and consider applying for <strong>ColiCare&trade;</strong>, our FREE $15,000 colic surgery reimbursement program. ColiCare combines a veterinary-directed wellness program with our best hindgut support supplements to give your horse the most comprehensive approach to preventive care.',
                    copyHis:
                        'Keep up the good work, and consider applying for <strong>ColiCare&trade;</strong>, our FREE $15,000 colic surgery reimbursement program. ColiCare combines a veterinary-directed wellness program with our best hindgut support supplements to give your horse the most comprehensive approach to preventive care.',
                    cta: 'Get Started',
                    url: '/colicare-eligible-supplements-1513pc'
                }
            ]
        }
    ],
    intro: [
        {
            type: 'Mare'
        },
        {
            type: 'Gelding'
        },
        {
            type: 'Stallion'
        }
    ]
});

$('#category label').find('input').prop('checked', false);
